import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { tableAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tableAnatomy.keys);

const baseStyle = definePartsStyle({
  th: {
    fontFamily: 'heading',
    fontWeight: 'medium',
    letterSpacing: 'normal',
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  td: {
    verticalAlign: 'top',
  },
});

const cellPadding = {
  sm: {
    py: 2,
    px: 2,
  },
  md: {
    py: 3,
    px: 3,
  },
};

const sizes = {
  sm: {
    th: {
      fontSize: 'xs',
      ...cellPadding.sm,
    },
    td: {
      lineHeight: 4,
      ...cellPadding.sm,
    },
  },
  md: {
    th: {
      fontSize: 'sm',
      ...cellPadding.md,
    },
    td: {
      lineHeight: 5,
      ...cellPadding.md,
    },
  },
};

const variantFlush = definePartsStyle({
  table: {
    tableLayout: 'fixed',
  },
  th: {
    bgColor: 'chakra-subtle-bg',
    borderBottomWidth: 2,
    color: 'muted',
    whiteSpace: 'normal',

    _first: {
      pl: 0,
    },
    _last: {
      pr: 0,
    },
  },
  td: {
    borderBottomWidth: 1,
    whiteSpace: 'normal',

    _first: {
      pl: 0,
    },
    _last: {
      pr: 0,
    },
  },
});

const variantStickyColumns = definePartsStyle({
  table: {
    tableLayout: 'fixed',
    borderCollapse: 'separate',
    borderSpacing: 0,
  },
  th: {
    bgColor: 'chakra-body-bg',
    borderBottomWidth: 2,
    color: 'muted',
    whiteSpace: 'normal',

    _first: {
      bgColor: 'chakra-body-bg',
      borderRightWidth: 1,
      position: 'sticky',
      left: 0,
    },

    _last: {
      borderLeftWidth: 1,
      position: 'sticky',
      right: 0,
    },
  },
  td: {
    whiteSpace: 'normal',

    _first: {
      bgColor: 'chakra-body-bg',
      borderRightWidth: 1,
      position: 'sticky',
      left: 0,
    },

    _last: {
      borderLeftWidth: 1,
      bgColor: 'chakra-body-bg',
      position: 'sticky',
      right: 0,
    },
  },
  tbody: {
    tr: {
      _odd: {
        td: {
          bgColor: 'chakra-subtle-bg',
        },
      },
    },
  },
});

const variantStickyHeader = definePartsStyle({
  table: {
    borderCollapse: 'separate',
    borderSpacing: 0,
    tableLayout: 'fixed',
  },
  thead: {
    position: 'sticky',
    top: 0,
  },
  th: {
    bgColor: 'chakra-subtle-bg',
    borderBottomWidth: 2,
    color: 'muted',
  },
  td: {
    borderBottomWidth: 1,
  },
});

export const tableTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {
    flush: variantFlush,
    'sticky-columns': variantStickyColumns,
    'sticky-header': variantStickyHeader,
  },
});
